module.exports = __webpack_public_path__ + "img/gpu_cover_c.1774f325.png";